import { useState, useEffect, useCallback, useRef } from 'react';
import MessengerApiService from '../../../../MessengerConfig/services/MessengerApiService';

export default function useMessengerStatus(agentId) {
  const [raw, setRaw] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const cancelRef = useRef({ cancelled: false });

  const fetchStatus = useCallback(async () => {
    if (!agentId || agentId === 'novo') {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const resp = await MessengerApiService.getStatus(agentId);
      if (cancelRef.current.cancelled) return;
      setRaw(resp.data);
    } catch (err) {
      if (cancelRef.current.cancelled) return;
      setError(
        err.response?.data?.error || err.message || 'Erro ao buscar status',
      );
      setRaw(null);
    } finally {
      if (!cancelRef.current.cancelled) setIsLoading(false);
    }
  }, [agentId]);

  useEffect(() => {
    cancelRef.current = { cancelled: false };
    fetchStatus();
    return () => {
      cancelRef.current.cancelled = true;
    };
  }, [fetchStatus]);

  const isConnected = !!raw?.connected;
  const tokenInvalid = !!raw?.token_validation_error;
  const isPaused = !!raw?.bot_paused;

  let statusVariant = 'neutral';
  let statusLabel = 'Desconectado';

  if (isConnected) {
    if (tokenInvalid) {
      statusVariant = 'danger';
      statusLabel = 'Token inválido';
    } else if (isPaused) {
      statusVariant = 'warning';
      statusLabel = 'IA pausada';
    } else {
      statusVariant = 'success';
      statusLabel = 'Conectado';
    }
  }

  let summary = '';
  if (isConnected && raw) {
    const parts = [];
    if (raw.page_name) parts.push(raw.page_name);
    if (raw.page_category) parts.push(raw.page_category);
    summary = parts.join(' · ');
  }

  return {
    isConnected,
    isLoading,
    error,
    statusLabel,
    statusVariant,
    summary,
    hasAlert: tokenInvalid,
    alertSeverity: tokenInvalid ? 'error' : null,
    refresh: fetchStatus,
    raw,
  };
}
